// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const flittle: PokeData = {
  "id": 955,
  "name": "flittle",
  "height": 2,
  "weight": 15,
  "base_experience": 51,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "growl",
    "psybeam",
    "peck",
    "confusion",
    "agility",
    "quick-attack",
    "uproar",
    "pluck",
    "disarming-voice",
    "baby-doll-eyes"
  ],
  "moves": [
    "growl",
    "peck",
    "quick-attack",
    "psychic",
    "reflect",
    "future-sight",
    "zen-headbutt",
    "psywave",
    "synchronize",
    "calm-mind",
    "healing-wish",
    "psy-pulse",
    "prismatic-cage"
  ],
  "evolution_chain": {
    "id": 500,
    "item": null,
    "species": [
      {
        "name": "flittle",
        "order": 926,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "espathra",
        "order": 927,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 955,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 30,
    "speed": 75,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
